<template>
  <div>
    {{message}}
  </div>
</template>

<script>
export default {
  name: 'Application',
  data () {
    return {
      message: 'TODO: /works/app'
    }
  }
}
</script>

<style module>
  
</style>
